import { JSX, useContext, useEffect, useState } from "react";
import { PageSection } from "../../../shared";
import { EcdReportGenerationStepProps, VisualizationOption } from "../interfaces";
import { EcdGenerateReportContext } from "../contexts/EcdGenerateReportContext";
import { QESCheckbox, QESTextInput } from "../../../shared/qes-standards";

const EcdReportGenerationExportDetails = (props: EcdReportGenerationStepProps): JSX.Element => {
  const wizardContext = useContext(EcdGenerateReportContext);

  const visualizationOptions: Array<VisualizationOption> = [
      {
        key: "include-filters-page",
        onChange: () => {
          wizardContext.setIncludeFilterPage(!wizardContext.includeFilterPage)
        },
        title: "Filters Page",
        value: wizardContext.includeFilterPage
      },
      {
        key: "include-adequacy-breakdown",
        onChange: () => {
          wizardContext.setIncludeAdequacyBreakdown(!wizardContext.includeAdequacyBreakdown)
        },
        title: "Adequacy Breakdown",
        value: wizardContext.includeAdequacyBreakdown
      },
      {
        key: "include-gap-overview",
        onChange: () => {
          wizardContext.setIncludeGapOverview(!wizardContext.includeGapOverview)
        },
        title: "Gap Overview",
        value: wizardContext.includeGapOverview
      },
      {
        key: "include-composite-fillable-gaps",
        onChange: () => {
          wizardContext.setIncludeCompositeFillableGaps(!wizardContext.includeCompositeFillableGaps)
        },
        title: "Composite Fillable Gaps",
        value: wizardContext.includeCompositeFillableGaps
      },
      {
        key: "include-gaps-by-age",
        onChange: () => {
          wizardContext.setIncludeGapsByAge(!wizardContext.includeGapsByAge)
        },
        title: "Gaps By Age",
        value: wizardContext.includeGapsByAge
      },
      {
        key: "include-exceptions",
        onChange: () => {
          wizardContext.setIncludeExceptions(!wizardContext.includeExceptions)
        },
        title: "Exceptions",
        value: wizardContext.includeExceptions
      },
      {
        key: "include-top-ten-specialties",
        onChange: () => {
          wizardContext.setIncludeTopSpecialties(!wizardContext.includeTopSpecialties)
        },
        title: "Top 10 Specialties By Gap Count",
        value: wizardContext.includeTopSpecialties
      },
      {
        key: "include-top-ten-counties",
        onChange: () => {
          wizardContext.setIncludeTopCounties(!wizardContext.includeTopCounties)
        },
        title: "Top 10 Counties By Gap Count",
        value: wizardContext.includeTopCounties
      },
      {
        key: "include-line-of-business",
        onChange: () => {
          wizardContext.setIncludeLineOfBusiness(!wizardContext.includeLineOfBusiness)
        },
        title: "Line of Business Overview",
        value: wizardContext.includeLineOfBusiness
      },
      {
        key: "include-county-status",
        onChange: () => {
          wizardContext.setIncludeCountyStatus(!wizardContext.includeCountyStatus)
        },
        title: "County Status Overview",
        value: wizardContext.includeCountyStatus
      },
  ]

  const [includeAll, setIncludeAll] = useState(visualizationOptions.every(vo => vo.value == true));

  useEffect(() => {
    props.pageIsValid(visualizationOptions.some(vo => vo.value == true && wizardContext.fileName.length > 0));
    setIncludeAll(visualizationOptions.every(vo => vo.value == true));
  }, [visualizationOptions, wizardContext.fileName])

  const handleSelectAll = () => {
    if (visualizationOptions.every(vo => vo.value == true)) {
      visualizationOptions.forEach(vo => vo.onChange());
      setIncludeAll(false);
    }
    else {
      visualizationOptions.forEach(vo => {
        if (vo.value == false) {
          vo.onChange();
        }
      });
      setIncludeAll(true);
    }
  };

  return (
    <PageSection>
      <br />
      <hr className="mt-0" />
      <div>
        <br />
        <p className="font-weight-bold text-gray-dark">Select Visualizations you would like to add to your report:</p>
        <div key={"select-all-pages"}>
          <QESCheckbox
            label={"Select All"}
            className="custom-control-inline"
            checked={includeAll}
            indeterminate={(!visualizationOptions.every(vo => vo.value == true) && !visualizationOptions.every(vo => vo.value == false))}
            onChange={() => {
              handleSelectAll();
            }}
            testId={"ecd-export-options__select-all-pages-checkbox"}
          />
        </div>
        {visualizationOptions.map((option) =>
          <div key={option.key}>
            <QESCheckbox
              label={option.title}
              className="custom-control-inline"
              checked={option.value}
              onChange={() => { option.onChange() }}
              testId={"ecd-export-options__" + option.key + "-checkbox"}
            />
          </div>)}
      </div>
      <div className="w-25">
        <br />
        <p className="font-weight-bold text-gray-dark">Report Details:</p>
        <QESCheckbox
          label="Add Graph Details to Report"
          className="custom-control-inline"
          checked={wizardContext.addGraphDetails}
          onChange={() => { wizardContext.setAddGraphDetails(!wizardContext.addGraphDetails) }}
          testId={"ecd-export-options__add-graph-details-checkbox"}
        />
        <br />
        <QESTextInput
          label="File Name"
          testId="ecd-export-options__file-name-input"
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => { wizardContext.setFileName(e.target.value) }}
          value={wizardContext.fileName}
          required={true}
          isValid={wizardContext.fileName.length > 0}
        />
      </div>
    </PageSection>
  );
}

export default EcdReportGenerationExportDetails;